import {ElementRef, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {Directive, Input} from '@angular/core';
import {selectUserHasPermission} from '../store/user-info/user-info.selector';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {tap} from 'rxjs';
import {UserPrivilege} from '../../features/main-page/types';

@Directive({
  selector: '[appPermission]',
  standalone: true,
})
export class PermissionsDirective implements OnInit {
  @Input()
  appPermission?: UserPrivilege | UserPrivilege[];
  disabled = false;

  private permission$?: Observable<boolean>;

  constructor(
    private readonly element: ElementRef,
    private readonly templateReference: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly store: Store,
  ) {
  }

  private createPermissionObservable() {
    if (!this.appPermission) {
      this.addTemplate();
      return;
    }

    this.permission$ = this.store
      .select(selectUserHasPermission(this.appPermission))
      .pipe(
        tap((hasPermission) => {
          if (hasPermission) {
            this.addTemplate();
          } else {
            this.clearTemplate();
          }
        }),
      );
  }

  ngOnInit() {
    this.createPermissionObservable();
    if (this.permission$) {
      this.permission$.subscribe();
    }
  }

  private addTemplate() {
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateReference);
  }

  private clearTemplate() {
    this.viewContainer.clear();
  }
}
